angular.module('com.vmware.vsphere.client.vm').service('vuiService', ['vuiWizardService', function (vuiWizardService) {
   return {
      createWizard: vuiWizardService
   };
}]);
